"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Replacer = exports.Replacer = {
  replaceConditions: function replaceConditions(endpointPath, conditions) {
    for (var key in conditions) {
      endpointPath = endpointPath.replace("#{" + key + "}", conditions[key]);
    }
    return endpointPath;
  }
};